export enum ThemeColor {
  RED = "RED",
  YELLOW = "YELLOW",
  GREEN = "GREEN",
  PURPLE = "PURPLE",
  PINK = "PINK",
}

export enum Track {
  LOW_TRACK = "lowTrack",
  MEDIUM_TRACK = "mediumTrack",
  HIGH_TRACK = "highTrack",
}
export interface RatingCheckboxProps {
  isWithRadioBtn?: boolean;
  themeColor: ThemeColor;
  className?: string;
  onTrackerChange: Function;
  options: Array<Optionstype>;
  infoContent: string;
  disabled: boolean;
}

export interface Optionstype {
  selected?: boolean;
  label: string;
  value: string;
}

export interface RatingCheckboxFormType {
  none?: RadioBtnType;
  tracker: RatingFormType;
}

export interface RadioBtnType {
  value: boolean;
  background: string;
}

export interface RatingFormType {
  value: string;
  range: Array<RangeFormType>;
}

export interface RangeFormType {
  label: string;
  value: string;
  backgroundColor: string;
  isActive: boolean;
  className: string;
  track: Track;
}

export interface RatingChangeType {
  none?: boolean;
  tracker: string;
}

export interface TrackRangeClickType {
  none: boolean;
  tracker: string;
  questionSelectedNdx: number;
}
